import { workoutMetricLabel } from './workoutMetricLabel';
import { isRunningWorkout, type RunningWorkout } from './runningWorkoutMetrics';

/** Sport label; training_load.method identifies the actual calculation. */
export function workoutStressLabel(workout: RunningWorkout & { training_load?: { method?: string | null; details?: Record<string, unknown> | null } | null }): string {
  if (workout.training_load?.method?.toUpperCase() === 'HR' && workout.training_load.details?.methodology_version === 'cycling_hrtss_friel_v1') return 'hrTSS';
  return workoutMetricLabel(isRunningWorkout(workout) ? 'rTss' : 'TSS');
}
